const buildTreeData = data => {
	const tree = [];
	const layers = {};
	const categoryCounts = {}; // To count occurrences of categories

	// First pass: Count occurrences of main categories
	for (const key in data) {
		const parts = key.split("_");
		const category = parts.slice(0, 2).join("_"); // Get the first two parts as the main category

		if (!categoryCounts[category]) {
			categoryCounts[category] = 0;
		}
		categoryCounts[category]++;
	}

	// Second pass: Organize the keys into layers based on category count
	for (const key in data) {
		const parts = key.split("_");
		const category = parts.slice(0, 2).join("_");
		const subItem = parts.slice(2).join("_");

		// If the category appears more than 2 times, use the first two parts as the parent
		// Otherwise, use only the first part as the parent
		const parentKey = categoryCounts[category] > 1 ? category : parts[0];

		if (!layers[parentKey]) {
			layers[parentKey] = {
				title: parentKey,
				value: parentKey,
				key: parentKey,
				children: []
			};
		}

		if (subItem) {
			layers[parentKey].children.push({
				title: key,
				value: key,
				key: key
			});
		}
	}

	// Push all main categories into the tree array
	for (const parentKey in layers) {
		tree.push(layers[parentKey]);
	}

	return tree;
};

// Utility function to extract child IDs from selected permissions
const extractChildIds = (selectedIds, treeData) => {
	const childIds = new Set();

	const findChildren = node => {
		if (!node.children || node.children.length === 0) {
			return;
		}
		node.children.forEach(child => {
			if (selectedIds.includes(child.id)) {
				childIds.add(child.id);
			}
			findChildren(child); // Recursively find children of the current child
		});
	};

	// Loop through each tree node and find children for selected IDs
	treeData.forEach(node => {
		if (selectedIds.includes(node.id)) {
			findChildren(node);
		}
	});

	return Array.from(childIds);
};

const formatKey = key => {
	if (!key) return "";
	if (typeof key !== "string") return key;
	const formatedKey = key
		.split(".")
		.pop()
		.replace(/_/g, " ")
		.replace(/\b\w/g, c => c.toUpperCase());

	return formatedKey;
};

const formateStringToKey = key => {
	if (!key) return "";
	if (typeof key !== "string") return key;
	return key.replace(/\s+/g, "_");
};

const generateId = () => `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

export { buildTreeData, extractChildIds, formatKey, formateStringToKey, generateId };
